module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921091149_T.4fe54547.jpg";